import { Navigate } from 'react-router-dom';
import { AccountMenu } from '@mfox/shared/ui/AccountMenu';
import { Logo } from '@mfox/shared/ui/Logo';
import { LoadingScreen } from '@mfox/shared/ui/StatusScreen';
import { useUser } from '@mfox/shared/contexts/UserContext';
import styles from './LoginPage.module.css';

/**
 * /login when the build signs in through Keycloak. The landing page's Sign in goes straight to Keycloak's own form, so
 * all this page does is explain an account Keycloak let in but the portal refused. Everyone else sent here (signed
 * out, after a lost session, a page opened while signed out) gets the landing page and its Sign in.
 *
 * Never start a sign-in from here by itself: after a lost session Keycloak may still be signed in, and a backend that
 * keeps refusing the token would bounce the browser between the two forever. Sign-out also passes through here.
 */
export function KeycloakLoginPage() {
  const { currentUser, isLoading, logout, accessError } = useUser();

  // A refusal is only known once the session restore has asked the backend, so wait for it.
  if (isLoading) return <LoadingScreen message="Loading…" />;
  if (currentUser || !accessError) return <Navigate to="/" replace />;

  return (
    <main className={styles.container}>
      <div className={styles.corner}><AccountMenu /></div>
      <div className={styles.card}>
        <Logo to="/" className={styles.logo} />
        <h1>Sign in</h1>
        <div className={styles.error} role="alert">{accessError}</div>
        <button type="button" onClick={logout}>Use a different account</button>
      </div>
    </main>
  );
}
